export default __webpack_public_path__ + "static/media/5.d81c3e7e.mp3";